module.exports = __webpack_public_path__ + "img/20190612_132334_025.525ba4f7.jpg";